
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { isNullOrEmpty } from "../../../../config/ENV";
import { candidateLogout } from "../../../../services/AuthService";
import BasicInfo from "./basicinfo/basicinfo";
import CandidateSkills from "./candskills/candidateskills";
import CareerHighlights from "./careerhighlights/careerhighlights";
import CandidateEducation from "./education/candidateeducation";
import JOBExperiences from "./experience/jobexperiences";
import JobPreferences from "./jobpreference/jobpreferences";
import Resume from "./resume/resume";
import firebase from "firebase/compat/app";
import "./../../../../assets/css/myProfile.css"



const MyProfile = () => {
  const [selectedName, setSelectedName] = useState("basicInfo");
  const { id } = useParams();
  const handleNameClick = (name) => {
    setSelectedName(name);
  };
  const renderComponent = () => {
    switch (id) {
      case "basicInfo":
        return <BasicInfo />;
      case "jobPreferences":
        return <JobPreferences />;
      case "candidateSkills":
        return <CandidateSkills />;
      case "jobExperiences":
        return <JOBExperiences />;
      case "careerHighlights":
        return <CareerHighlights />;
      case "CandidateEducation":
        return <CandidateEducation />;
      case "Resume":
        return <Resume />;
      default:
        return <BasicInfo />;
    }
  };

  const getActive = (name) => {
    var classnames =
      "  min-lg:py-4  min-lg:px-7 t-myprofile-py-2 hover:text-primary-blue  menuItem max-md:py-4  ";
    if (name === id) {
      classnames =
        "active min-lg:py-4  min-lg:px-7 t-myprofile-py-2 hover:text-primary-blue  menuItem max-md:py-4  ";
    }
    return classnames;
  };


  const handleLogout = () => {
    candidateLogout()
      .then((response) => {
        try {
          if (response.message != null) {
            if (response.data.error_message !== "") {
            }
          } else {
            firebase
              .auth()
              .signOut()
              .then(function () {
                window.localStorage.removeItem("user");
                window.localStorage.removeItem("account");
                window.localStorage.clear();
                sessionStorage.clear();
                window.location.href = "/";
              })
              .catch(function () {});
          }
        } catch (err) {}
      })
      .catch((error) => {
        firebase
          .auth()
          .signOut()
          .then(function () {
            window.localStorage.removeItem("user");
            window.localStorage.removeItem("account");
            window.localStorage.clear();
            sessionStorage.clear();
            window.location.href = "/";
          })
          .catch(function () {});
      });
  };

  return (
    <>
      {renderComponent()}

      {/* <div className="smartIntro min-sm:mb-14 max-sm:mb-8 min-sm:border-l-4 border-primary-blue min-sm:px-12 basis-full order-1 col-span-4 row-start-1">

                            <div className="Name max-sm:px-7">
                                <div className="font-normal text-3xl">Edwin <strong className="font-semibold">Taylor</strong></div>
                                <div className="font-normal text-lg text-primary-blue py-2">Experienced Medical Receptionist</div>
                            </div>
    
                            <div className="max-sm:bg-primary-blue2 flex flex-wrap min-sm:gap-14 max-sm:gap-7 text-center justify-center min-sm:text-left min-sm:justify-start max-sm:py-5 max-sm:mt-2">
                                <div className="font-semibold text-base text-Blue-700 min-sm:text-primary-dark">
                                    <svg className="inline max-sm:hidden" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M9 5.625C8.06802 5.625 7.3125 6.38052 7.3125 7.3125C7.3125 8.24448 8.06802 9 9 9C9.93198 9 10.6875 8.24448 10.6875 7.3125C10.6875 6.38052 9.93198 5.625 9 5.625ZM6.1875 7.3125C6.1875 5.7592 7.4467 4.5 9 4.5C10.5533 4.5 11.8125 5.7592 11.8125 7.3125C11.8125 8.8658 10.5533 10.125 9 10.125C7.4467 10.125 6.1875 8.8658 6.1875 7.3125Z" fill="black"/>
                                        <path fillRule="evenodd" clipRule="evenodd" d="M9 2.25C7.65734 2.25 6.36967 2.78337 5.42027 3.73277C4.47087 4.68217 3.9375 5.96984 3.9375 7.3125C3.9375 9.64122 5.23791 11.7617 6.61197 13.3418C7.29212 14.124 7.97372 14.7546 8.4854 15.1896C8.68775 15.3616 8.86288 15.5024 9 15.6094C9.13711 15.5024 9.31225 15.3616 9.5146 15.1896C10.0263 14.7546 10.7079 14.124 11.388 13.3418C12.7621 11.7617 14.0625 9.64122 14.0625 7.3125C14.0625 5.96984 13.5291 4.68217 12.5797 3.73277C11.6303 2.78337 10.3427 2.25 9 2.25ZM9 16.3125C8.67743 16.7733 8.67727 16.7732 8.67709 16.7731L8.67663 16.7728L8.67531 16.7718L8.67115 16.7689L8.65685 16.7587C8.64469 16.75 8.62735 16.7376 8.60517 16.7214C8.56082 16.689 8.49708 16.6418 8.41673 16.5803C8.25608 16.4576 8.02869 16.2779 7.75679 16.0468C7.21378 15.5852 6.48913 14.915 5.76303 14.08C4.32459 12.4258 2.8125 10.0463 2.8125 7.3125C2.8125 5.67147 3.4644 4.09766 4.62478 2.93728C5.78516 1.7769 7.35897 1.125 9 1.125C10.641 1.125 12.2148 1.7769 13.3752 2.93728C14.5356 4.09766 15.1875 5.67147 15.1875 7.3125C15.1875 10.0463 13.6754 12.4258 12.237 14.08C11.5109 14.915 10.7862 15.5852 10.2432 16.0468C9.97131 16.2779 9.74392 16.4576 9.58327 16.5803C9.50292 16.6418 9.43918 16.689 9.39483 16.7214C9.37265 16.7376 9.35531 16.75 9.34315 16.7587L9.32885 16.7689L9.32469 16.7718L9.32337 16.7728L9.32291 16.7731C9.32273 16.7732 9.32257 16.7733 9 16.3125ZM9 16.3125L9.32291 16.7731C9.12923 16.9087 8.87077 16.9087 8.67709 16.7731L9 16.3125Z" fill="black"/>
                                    </svg>
                                    San Jose, CA <br/> <span className="font-normal text-xs text-neutral-700 min-sm:hidden">Work Location</span>
                                </div>
                                <div className="font-semibold text-base text-Blue-700 min-sm:text-primary-dark">
                                    <svg className="inline max-sm:hidden" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M8 3.5C8.31066 3.5 8.5625 3.75184 8.5625 4.0625V5.1875C8.5625 5.49816 8.31066 5.75 8 5.75C7.68934 5.75 7.4375 5.49816 7.4375 5.1875V4.0625C7.4375 3.75184 7.68934 3.5 8 3.5Z" fill="black"/>
                                        <path fillRule="evenodd" clipRule="evenodd" d="M8 10.25C8.31066 10.25 8.5625 10.5018 8.5625 10.8125V11.9375C8.5625 12.2482 8.31066 12.5 8 12.5C7.68934 12.5 7.4375 12.2482 7.4375 11.9375V10.8125C7.4375 10.5018 7.68934 10.25 8 10.25Z" fill="black"/>
                                        <path fillRule="evenodd" clipRule="evenodd" d="M8 1.8125C4.58274 1.8125 1.8125 4.58274 1.8125 8C1.8125 11.4173 4.58274 14.1875 8 14.1875C11.4173 14.1875 14.1875 11.4173 14.1875 8C14.1875 4.58274 11.4173 1.8125 8 1.8125ZM0.6875 8C0.6875 3.96142 3.96142 0.6875 8 0.6875C12.0386 0.6875 15.3125 3.96142 15.3125 8C15.3125 12.0386 12.0386 15.3125 8 15.3125C3.96142 15.3125 0.6875 12.0386 0.6875 8Z" fill="black"/>
                                        <path fillRule="evenodd" clipRule="evenodd" d="M7.15625 5.75C6.93247 5.75 6.71786 5.83889 6.55963 5.99713C6.40139 6.15536 6.3125 6.36997 6.3125 6.59375C6.3125 6.81753 6.40139 7.03214 6.55963 7.19037C6.71786 7.34861 6.93247 7.4375 7.15625 7.4375H8.84375C9.3659 7.4375 9.86665 7.64492 10.2359 8.01413C10.6051 8.38335 10.8125 8.8841 10.8125 9.40625C10.8125 9.92839 10.6051 10.4292 10.2359 10.7984C9.86665 11.1676 9.3659 11.375 8.84375 11.375H6.3125C6.00184 11.375 5.75 11.1232 5.75 10.8125C5.75 10.5018 6.00184 10.25 6.3125 10.25H8.84375C9.06753 10.25 9.28214 10.1611 9.44037 10.0029C9.59861 9.84464 9.6875 9.63003 9.6875 9.40625C9.6875 9.18247 9.59861 8.96786 9.44037 8.80963C9.28214 8.65139 9.06753 8.5625 8.84375 8.5625H7.15625C6.6341 8.5625 6.13335 8.35508 5.76413 7.98587C5.39492 7.61665 5.1875 7.1159 5.1875 6.59375C5.1875 6.0716 5.39492 5.57085 5.76413 5.20163C6.13335 4.83242 6.6341 4.625 7.15625 4.625H9.6875C9.99816 4.625 10.25 4.87684 10.25 5.1875C10.25 5.49816 9.99816 5.75 9.6875 5.75H7.15625Z" fill="black"/>
                                    </svg>
                                    $28 - $34/hr <br/> <span className="font-normal text-xs text-neutral-700 min-sm:hidden">Desire Salary</span>
                                </div>
                                <div className="font-semibold text-base text-Blue-700 min-sm:text-primary-dark">
                                    <svg className="inline max-sm:hidden" width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M0.25 2.375C0.25 1.75368 0.75368 1.25 1.375 1.25H12.625C13.2463 1.25 13.75 1.75368 13.75 2.375V13.625C13.75 14.2463 13.2463 14.75 12.625 14.75H1.375C0.75368 14.75 0.25 14.2463 0.25 13.625V2.375ZM12.625 2.375H1.375V13.625H12.625V2.375Z" fill="black"/>
                                        <path fillRule="evenodd" clipRule="evenodd" d="M10.375 0.125C10.6857 0.125 10.9375 0.37684 10.9375 0.6875V2.9375C10.9375 3.24816 10.6857 3.5 10.375 3.5C10.0643 3.5 9.8125 3.24816 9.8125 2.9375V0.6875C9.8125 0.37684 10.0643 0.125 10.375 0.125Z" fill="black"/>
                                        <path fillRule="evenodd" clipRule="evenodd" d="M3.625 0.125C3.93566 0.125 4.1875 0.37684 4.1875 0.6875V2.9375C4.1875 3.24816 3.93566 3.5 3.625 3.5C3.31434 3.5 3.0625 3.24816 3.0625 2.9375V0.6875C3.0625 0.37684 3.31434 0.125 3.625 0.125Z" fill="black"/>
                                        <path fillRule="evenodd" clipRule="evenodd" d="M0.25 5.1875C0.25 4.87684 0.50184 4.625 0.8125 4.625H13.1875C13.4982 4.625 13.75 4.87684 13.75 5.1875C13.75 5.49816 13.4982 5.75 13.1875 5.75H0.8125C0.50184 5.75 0.25 5.49816 0.25 5.1875Z" fill="black"/>
                                        <path fillRule="evenodd" clipRule="evenodd" d="M3.90625 8C3.90625 7.68934 4.15809 7.4375 4.46875 7.4375H6.4375C6.65373 7.4375 6.85082 7.56144 6.94448 7.75633C7.03815 7.95122 7.01181 8.18255 6.87674 8.35139L6.25416 9.12962C6.43656 9.25191 6.59382 9.40896 6.71661 9.59235C6.87113 9.82311 6.9663 10.0884 6.9937 10.3648C7.02109 10.6412 6.97985 10.92 6.87363 11.1766C6.76742 11.4332 6.59951 11.6597 6.38482 11.8358C6.17011 12.012 5.91526 12.1324 5.64285 12.1865C5.37044 12.2405 5.0889 12.2265 4.82321 12.1457C4.55751 12.0648 4.31588 11.9197 4.11974 11.723C3.90034 11.5031 3.90077 11.147 4.1207 10.9276C4.34064 10.7081 4.69679 10.7086 4.9162 10.9285C4.98158 10.9941 5.06212 11.0424 5.15069 11.0694C5.23925 11.0963 5.3331 11.101 5.4239 11.083C5.5147 11.065 5.59966 11.0248 5.67122 10.9661C5.74279 10.9074 5.79876 10.8319 5.83416 10.7464C5.86957 10.6608 5.88331 10.5679 5.87418 10.4758C5.86505 10.3836 5.83333 10.2952 5.78182 10.2183C5.73031 10.1414 5.66062 10.0783 5.57892 10.0348C5.49722 9.99128 5.40604 9.96859 5.31346 9.96875C5.09706 9.96912 4.89964 9.84532 4.80573 9.65035C4.71182 9.45539 4.73808 9.22384 4.87326 9.05486L5.26715 8.5625H4.46875C4.15809 8.5625 3.90625 8.31066 3.90625 8Z" fill="black"/>
                                        <path fillRule="evenodd" clipRule="evenodd" d="M9.50159 7.49689C9.69216 7.59217 9.81253 7.78694 9.81253 8V11.6563C9.81253 11.9669 9.56069 12.2188 9.25003 12.2188C8.93937 12.2188 8.68753 11.9669 8.68753 11.6563V9.125L8.46253 9.29375C8.214 9.48015 7.86143 9.42978 7.67503 9.18125C7.48864 8.93272 7.539 8.58015 7.78753 8.39375L8.91253 7.55C9.08298 7.42217 9.31103 7.40161 9.50159 7.49689Z" fill="black"/>
                                    </svg>
                                    Immediately <br/> <span className="font-normal text-xs text-neutral-700 min-sm:hidden">Availability</span>
                                </div>
                            </div>

                        </div> */}

<div className="profileMenu_wrapper 
                            min-lg:order-2 max-lg:order-1 
                            min-md:col-span-full min-lg:col-span-2 min-2xl:col-span-1 max-md:col-span-full
                            ">

                    <div className="profileMenu_container 
                                 max-lg:w-full 
                                 max-lg:overflow-x-scroll hover:scrollbar-thin scrollbar-none scrollbar-thumb-rounded-md scrollbar-thumb-Blue-600 scrollbar-track-Gray-200
                    ">
                        <div className="profileMenu_block min-lg:rounded-xl min-lg:py-4 max-lg:mb-2  bg-primary-white min-lg:shadow-md min-lg:border-primary-gray2 min-lg:border-[1px] border-solid">
                            <ul className="profileMenu text-sm
                                        max-lg:flex max-lg:flex-row max-lg:flex-nowrap
                                        max-lg:pl-5 max-lg:pr-7 max-lg:gap-7 mb-0
                            ">            <li
                className={`${getActive("basicInfo")}`}
                onClick={() => handleNameClick("basicInfo")}
              >
                <Link to={"/myProfile/basicInfo"}>
                  <span className="inline-block align-bottom w-5 h-5 mr-2">
                  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.25 17C5.25 17.4142 5.58579 17.75 6 17.75C6.41421 17.75 6.75 17.4142 6.75 17H5.25ZM15.25 17C15.25 17.4142 15.5858 17.75 16 17.75C16.4142 17.75 16.75 17.4142 16.75 17H15.25ZM5.25 16V17H6.75V16H5.25ZM16.75 17V16H15.25V17H16.75ZM16.75 16C16.75 12.8244 14.1756 10.25 11 10.25V11.75C13.3472 11.75 15.25 13.6528 15.25 16H16.75ZM6.75 16C6.75 13.6528 8.65279 11.75 11 11.75V10.25C7.82436 10.25 5.25 12.8244 5.25 16H6.75ZM13.25 8C13.25 9.24264 12.2426 10.25 11 10.25V11.75C13.0711 11.75 14.75 10.0711 14.75 8H13.25ZM11 10.25C9.75736 10.25 8.75 9.24264 8.75 8H7.25C7.25 10.0711 8.92893 11.75 11 11.75V10.25ZM8.75 8C8.75 6.75736 9.75736 5.75 11 5.75V4.25C8.92893 4.25 7.25 5.92893 7.25 8H8.75ZM11 5.75C12.2426 5.75 13.25 6.75736 13.25 8H14.75C14.75 5.92893 13.0711 4.25 11 4.25V5.75ZM20.25 11C20.25 16.1086 16.1086 20.25 11 20.25V21.75C16.9371 21.75 21.75 16.9371 21.75 11H20.25ZM11 20.25C5.89137 20.25 1.75 16.1086 1.75 11H0.25C0.25 16.9371 5.06294 21.75 11 21.75V20.25ZM1.75 11C1.75 5.89137 5.89137 1.75 11 1.75V0.25C5.06294 0.25 0.25 5.06294 0.25 11H1.75ZM11 1.75C16.1086 1.75 20.25 5.89137 20.25 11H21.75C21.75 5.06294 16.9371 0.25 11 0.25V1.75Z" fill="#333333"/>
</svg>

                  </span>
                  My Basic Info
                </Link>
              </li>
              <li
                className={`${getActive("jobPreferences")}`}
                onClick={() => handleNameClick("jobPreferences")}
              >
                <Link to={"/myProfile/jobPreferences"}>
                  <span className="inline-block align-bottom w-5 h-5 mr-2">
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9.16663 16.5H19.25"
                        stroke="#333333"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                      <path
                        d="M2.75 16.5H5.5"
                        stroke="#333333"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                      <path
                        d="M5.5 18.3333L5.5 14.6666"
                        stroke="#333333"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                      <path
                        d="M18.3334 11H19.25"
                        stroke="#333333"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                      <path
                        d="M2.75 11H14.6667"
                        stroke="#333333"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                      <path
                        d="M14.6666 12.8333L14.6666 9.16663"
                        stroke="#333333"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                      <path
                        d="M12.8334 5.5H19.25"
                        stroke="#333333"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                      <path
                        d="M2.75 5.5H9.16667"
                        stroke="#333333"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                      <path
                        d="M9.16663 7.33329L9.16663 3.66663"
                        stroke="#333333"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                  </span>
                  Job Preferences
                </Link>
              </li>
              <li
                className={`${getActive("candidateSkills")}`}
                onClick={() => handleNameClick("candidateSkills")}
              >
                <Link to={"/myProfile/candidateSkills"}>
                  <span className="inline-block align-bottom w-5 h-5 mr-2">
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.25 17.25H11.75M6.25 17.25V12.6667M6.25 17.25H1.35C1.01863 17.25 0.75 16.9814 0.75 16.65V13.2667C0.75 12.9353 1.01863 12.6667 1.35 12.6667H6.25M11.75 17.25V6.25M11.75 17.25H16.65C16.9814 17.25 17.25 16.9814 17.25 16.65V1.35C17.25 1.01863 16.9814 0.75 16.65 0.75H12.35C12.0186 0.75 11.75 1.01863 11.75 1.35V6.25M11.75 6.25H6.85C6.51863 6.25 6.25 6.51863 6.25 6.85V12.6667"
                        stroke="#333333"
                        strokeWidth="1.5"
                      ></path>
                    </svg>
                  </span>
                  My Skills
                </Link>
              </li>
              <li
                className={`${getActive("jobExperiences")}`}
                onClick={() => handleNameClick("jobExperiences")}
              >
                <Link to={"/myProfile/jobExperiences"}>
                  <span className="inline-block align-bottom w-5 h-5 mr-2">
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.41663 8.25917L6.42579 8.24898"
                        stroke="#333333"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                      <path
                        d="M10.0834 8.25917L10.0925 8.24898"
                        stroke="#333333"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                      <path
                        d="M6.41663 11.9258L6.42579 11.9156"
                        stroke="#333333"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                      <path
                        d="M10.0834 11.9258L10.0925 11.9156"
                        stroke="#333333"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                      <path
                        d="M6.41663 15.5925L6.42579 15.5824"
                        stroke="#333333"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                      <path
                        d="M10.0834 15.5925L10.0925 15.5824"
                        stroke="#333333"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                      <path
                        d="M13.75 19.25H3.35C3.01863 19.25 2.75 18.9814 2.75 18.65V5.18333C2.75 4.85196 3.01863 4.58333 3.35 4.58333H8.25V3.35C8.25 3.01863 8.51863 2.75 8.85 2.75H13.15C13.4814 2.75 13.75 3.01863 13.75 3.35V8.25M13.75 19.25H18.65C18.9814 19.25 19.25 18.9814 19.25 18.65V8.85C19.25 8.51863 18.9814 8.25 18.65 8.25H13.75M13.75 19.25V15.5833M13.75 8.25V11.9167M13.75 11.9167H15.5833M13.75 11.9167V15.5833M13.75 15.5833H15.5833"
                        stroke="#333333"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                  </span>
                  Job Experiences{" "}
                </Link>
              </li>

              <li
                className={`${getActive("careerHighlights")}`}
                onClick={() => handleNameClick("careerHighlights")}
              >
                 <Link to={"/myProfile/careerHighlights"}>
                  <span className="inline-block align-bottom w-5 h-5 mr-2">
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.0825 9.57463L16.5 1.83337M8.53978 9.74628L4.58333 1.83337M11.6981 9.21059L8.09875 1.83337M13.1633 1.83337L12.21 4.12504M5.5 14.6667C5.5 17.7043 7.96243 20.1667 11 20.1667C14.0376 20.1667 16.5 17.7043 16.5 14.6667C16.5 11.6291 14.0376 9.16671 11 9.16671C7.96243 9.16671 5.5 11.6291 5.5 14.6667Z"
                        stroke="#333333"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                  </span>
                  Career Hightlights
                </Link>
              </li>

              <li
                className={`${getActive("CandidateEducation")}`}
                onClick={() => handleNameClick("CandidateEducation")}
              >
                <Link to={"/myProfile/CandidateEducation"}>
                  <span className="inline-block align-bottom w-5 h-5 mr-2">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M9.70588 1.94853C9.88971 1.85049 10.1103 1.85049 10.2941 1.94853L19.6691 6.94853C19.8728 7.05715 20 7.26918 20 7.5C20 7.73082 19.8728 7.94285 19.6691 8.05147L10.2941 13.0515C10.1103 13.1495 9.88971 13.1495 9.70588 13.0515L0.330882 8.05147C0.127218 7.94285 0 7.73082 0 7.5C0 7.26918 0.127218 7.05715 0.330882 6.94853L9.70588 1.94853ZM1.95312 7.5L10 11.7917L18.0469 7.5L10 3.20833L1.95312 7.5Z" fill="#333333"/>
<path fillRule="evenodd" clipRule="evenodd" d="M9.4485 7.20585C9.61094 6.90128 9.98952 6.78606 10.2941 6.9485L14.9816 9.4485C15.1853 9.55712 15.3125 9.76915 15.3125 9.99997V18.75C15.3125 19.0951 15.0326 19.375 14.6875 19.375C14.3423 19.375 14.0625 19.0951 14.0625 18.75V10.375L9.70585 8.05144C9.40128 7.889 9.28606 7.51042 9.4485 7.20585Z" fill="#333333"/>
<path fillRule="evenodd" clipRule="evenodd" d="M2.81251 8.03909C3.15768 8.03909 3.43751 8.31891 3.43751 8.66409V12.9219L3.43888 12.9237C3.90238 13.5463 5.9575 15.9375 10 15.9375C14.0425 15.9375 16.0977 13.5463 16.5612 12.9237L16.5625 12.9219V8.66409C16.5625 8.31891 16.8423 8.03909 17.1875 8.03909C17.5327 8.03909 17.8125 8.31891 17.8125 8.66409V12.9297L17.8125 12.9324C17.8114 13.1998 17.7234 13.4596 17.5619 13.6727C16.9752 14.4598 14.593 17.1875 10 17.1875C5.40698 17.1875 3.02482 14.4598 2.43812 13.6727C2.27661 13.4596 2.18864 13.1998 2.18751 12.9324L2.1875 12.9297L2.18751 8.66409C2.18751 8.31891 2.46733 8.03909 2.81251 8.03909Z" fill="#333333"/>
</svg>

          
                  </span>
                  Education{" "}
                </Link>
              </li>
              <li
                className={`${getActive("Resume")}`}
                onClick={() => handleNameClick("Resume")}
              >
                <Link to={"/myProfile/Resume"}>
                  <span className="inline-block align-bottom w-5 h-5 mr-2">
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M3.66663 19.5667V2.43337C3.66663 2.102 3.93526 1.83337 4.26663 1.83337H14.8764C15.0356 1.83337 15.1882 1.89659 15.3007 2.00911L18.1576 4.86597C18.2701 4.97849 18.3333 5.13111 18.3333 5.29024V19.5667C18.3333 19.8981 18.0647 20.1667 17.7333 20.1667H4.26663C3.93526 20.1667 3.66663 19.8981 3.66663 19.5667Z"
                        stroke="#333333"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                      <path
                        d="M14.6666 4.90004V2.15746C14.6666 1.97847 14.8117 1.83337 14.9907 1.83337C15.0767 1.83337 15.1591 1.86752 15.2199 1.9283L18.2384 4.94678C18.2991 5.00756 18.3333 5.09 18.3333 5.17595C18.3333 5.35494 18.1882 5.50004 18.0092 5.50004H15.2666C14.9353 5.50004 14.6666 5.23141 14.6666 4.90004Z"
                        fill="#333333"
                        stroke="#333333"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                      <path
                        d="M7.33337 9.16663L14.6667 9.16663"
                        stroke="#333333"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                      <path
                        d="M7.33337 16.5L14.6667 16.5"
                        stroke="#333333"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                      <path
                        d="M7.33337 12.8334L11 12.8334"
                        stroke="#333333"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                  </span>
                  Resume{" "}
                </Link>
              </li>
              <li
                className={`${getActive("Logout")}`}
                onClick={handleLogout}
              >
                <a className="temanics-link-pointer">
                  <span className="inline-block align-bottom w-5 h-5 mr-2 ">
                  <svg
                    className=" pb-1 mb-1 h-6 w-full min-md:h-8"
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M14.467 6.90449C14.7355 6.636 15.1708 6.636 15.4393 6.90449L19.0486 10.5139C19.3171 10.7823 19.3171 11.2177 19.0486 11.4861L15.4393 15.0955C15.1708 15.364 14.7355 15.364 14.467 15.0955C14.1985 14.827 14.1985 14.3917 14.467 14.1232L17.5902 11L14.467 7.87676C14.1985 7.60828 14.1985 7.17297 14.467 6.90449Z"
                      fill="black"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M8.25 11C8.25 10.6203 8.5578 10.3125 8.9375 10.3125H18.5625C18.9422 10.3125 19.25 10.6203 19.25 11C19.25 11.3797 18.9422 11.6875 18.5625 11.6875H8.9375C8.5578 11.6875 8.25 11.3797 8.25 11Z"
                      fill="black"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M3.15273 3.15273C3.41059 2.89487 3.76033 2.75 4.125 2.75H8.9375C9.3172 2.75 9.625 3.0578 9.625 3.4375C9.625 3.8172 9.3172 4.125 8.9375 4.125L4.125 4.125L4.125 17.875H8.9375C9.3172 17.875 9.625 18.1828 9.625 18.5625C9.625 18.9422 9.3172 19.25 8.9375 19.25H4.125C3.76033 19.25 3.41059 19.1051 3.15273 18.8473C2.89487 18.5894 2.75 18.2397 2.75 17.875V4.125C2.75 3.76033 2.89487 3.41059 3.15273 3.15273Z"
                      fill="black"
                    />
                  </svg>
                  </span>
                  Logout
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};
export default MyProfile;

